import { Checkmark } from '@mint-lib/icons';
import {
  Card,
  FeaturedIcon,
  typographyVariants,
} from '@mint-lib/tw-components';

function ThanksRouteComponent() {
  return (
    <Card
      hover={'noHover'}
      className="flex h-[50vh] w-212.5 items-center justify-center overflow-hidden px-13"
      contentClassName="p-0"
    >
      <div className={'flex flex-col items-center justify-center gap-8'}>
        <div className={'flex flex-col items-center justify-center gap-4'}>
          <FeaturedIcon icon={<Checkmark />} className={'h-16 w-16'} />
          <h2
            className={typographyVariants({ variant: 'h2', color: 'primary' })}
          >
            Thank you!
          </h2>
        </div>
        <p
          className={typographyVariants({
            variant: 'bodyLong01',
            color: 'secondary',
            className: 'text-center',
          })}
        >
          Now MINT Enterprise will take into consideration the changes.
        </p>
      </div>
    </Card>
  );
}

export default ThanksRouteComponent;
